import React from "react";
import "./button.scss";
const Button = ({ varient, href, as, type, value, children }) => {
  const getVarient = () => {
    return varient ? `button ${varient}` : "button";
  };
  if (href) {
    return (
      <a href={href} className={getVarient()}>
        {children}
      </a>
    );
  } else if (as === "input") {
    return <input type={type} value={value} className={getVarient()} />;
  }
  return (
    <button type={type} className={getVarient()}>
      {children}
    </button>
  );
};

export default Button;
